// src/app.js
// Core app.js - module imports are handled separately via PHP filters
// Child themes can filter modules using: add_filter('ronikdesigns_js_modules', 'your_filter_function');

jQuery(document).ready(function ($) {
  $('html').removeClass('no-js');

  document.addEventListener('DOMContentLoaded', function () {
    if (window.wp && wp.i18n) {
      wp.i18n.setLocaleData({
        'text direction\u0004ltr': ['ltr']
      });
    } else {
      console.error('wp.i18n is not available');
    }
  });

  var doit;
  window.onresize = function () {
    clearTimeout(doit);
    doit = setTimeout(() => {

    }, 100);
  };
});

// WebP background image support detection
function detectWebPSupport() {
  return new Promise((resolve) => {
    // Method 1: Canvas detection
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;

    try {
      const dataURL = canvas.toDataURL('image/webp');
      const isWebP = dataURL.indexOf('data:image/webp') === 0;
      resolve(isWebP);
    } catch (e) {
      // Method 2: Image detection
      const webp = new Image();
      webp.onload = function () {
        resolve(true);
      };
      webp.onerror = function () {
        resolve(false);
      };
      webp.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAADsAD+JaQAA3AAAAAA';
    }
  });
}

// Swap background images to WebP if supported
async function swapBackgroundImages() {
  const supportsWebP = await detectWebPSupport();

  const elements = document.querySelectorAll('.webp-bg-swap');

  elements.forEach((element, index) => {
    const webpBg = element.style.getPropertyValue('--webp-bg');
    const fallbackBg = element.style.getPropertyValue('--bg-fallback');

    if (supportsWebP && webpBg) {
      // Use WebP directly - no fallback loading
      element.style.setProperty('background-image', webpBg, 'important');
    } else if (fallbackBg) {
      // Use fallback only if WebP not supported
      element.style.setProperty('background-image', fallbackBg, 'important');
    }
  });
}

// Initialize WebP background swapping with retry
function initWebPSwapping() {
  swapBackgroundImages();

  // Retry after a short delay in case elements load later
  setTimeout(swapBackgroundImages, 100);
  setTimeout(swapBackgroundImages, 500);
}

document.addEventListener('DOMContentLoaded', initWebPSwapping);

